/* AGAINORA EXPERIENCE SYSTEM 2026 */
(function(){
var root=document.documentElement;
var reducedMotion=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var scrollFrame=0,scrollContainer=null,revealObserver=null,mutationObserver=null,mutationFrame=0,pendingEnhancementRoots=[];
var customSelectId=0,customSelectEventsBound=false,customSelectPositionFrame=0;
var mobileFilterMedia=window.matchMedia ? window.matchMedia('(max-width: 989px)') : null,localizationSelectEventsBound=false;
var activeMobileFilter=null,mobileFilterTrigger=null,mobileFilterScrollY=0,mobileFilterBodyStyles=null;
var mobileFilterEventsBound=false;
var revealSelector=[
    '.editorial-home .editorial-hero__copy > *',
    '.editorial-home .editorial-hero__lookbook-card',
    '.editorial-home .editorial-promise',
    '.editorial-home .editorial-section__head',
    '.editorial-home .editorial-category-card',
    '.editorial-home .editorial-product-card',
    '.editorial-home .editorial-trust-panel',
    '.codex-collection-results .product-grid__item',
    '.brands-directory__header',
    '.brands-directory__card',
    '.codex-same-size__head',
    '.codex-same-size__card',
    '.codex-recently-viewed__card'
].join(',');

  function currentScrollTop() {
    var containerTop = scrollContainer && scrollContainer !== document.documentElement && scrollContainer !== document.body
      ? (scrollContainer.scrollTop || 0)
      : 0;
    var documentTop = window.scrollY || document.documentElement.scrollTop || 0;
    return Math.max(containerTop, documentTop);
  }

  function applyScrollState() {
    scrollFrame = 0;
    document.body.classList.toggle('cw-scrolled', currentScrollTop() > 18);
  }

  function requestScrollState() {
    if (scrollFrame) return;
    scrollFrame = window.requestAnimationFrame(applyScrollState);
  }

  function bindScrollState() {
    var pageWrapper = document.querySelector('.page-wrapper');
    scrollContainer = pageWrapper || document.scrollingElement || document.documentElement;
    scrollContainer.addEventListener('scroll', requestScrollState, { passive: true });
    if (scrollContainer !== window) window.addEventListener('scroll', requestScrollState, { passive: true });
    applyScrollState();
  }

  if (!reducedMotion && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('cw-reveal--visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
  }

  function nodesIncludingScope(scope, selector) {
    var nodes = [];
    if (!scope || !scope.querySelectorAll) return nodes;
    if (scope.matches && scope.matches(selector)) nodes.push(scope);
    return nodes.concat(Array.prototype.slice.call(scope.querySelectorAll(selector)));
  }

  function fixCustomerPrivacyPolicyLinks(scope) {
    nodesIncludingScope(scope || document, '#shopify-pc__banner__body-policy-link').forEach(function (link) {
      var route = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
      link.href = route + 'pages/privacy-rights';
    });
  }

  function normalizeVisibleProductSizes(scope) {
    nodesIncludingScope(scope || document, '.codex-pdp__title,.codex-pdp__crumbs,a[href*="/products/"]').forEach(function (node) {
      var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      var textNode;
      while ((textNode = walker.nextNode())) {
        var original = textNode.nodeValue || '';
        var normalized = original
          .replace(/Ws*(d+)s*Ls*(d+)/gi, 'W$1 L$2')
          .replace(/(Sizes+)(d+)s*Ls*(d+)/gi, '$1W$2 L$3');
        if (normalized !== original) textNode.nodeValue = normalized;
      }
    });
  }
  function prepareReveals(scope) {
    nodesIncludingScope(scope || document, revealSelector).forEach(function (node, index) {
      if (node.dataset.cwRevealReady === 'true') return;
      node.dataset.cwRevealReady = 'true';
      node.classList.add('cw-reveal');
      node.style.setProperty('--cw-delay', Math.min(index % 5, 4) * 42 + 'ms');

      if (reducedMotion || !('IntersectionObserver' in window) || !revealObserver) {
        node.classList.add('cw-reveal--visible');
        return;
      }

      revealObserver.observe(node);
    });
  }

  function preparePressFeedback(scope) {
    var selector = '.editorial-button, .codex-pdp__add, .catalog-controls__form button, .product-card-wrapper button';
    nodesIncludingScope(scope || document, selector).forEach(function (control) {
      if (control.dataset.cwPressReady === 'true') return;
      control.dataset.cwPressReady = 'true';
      control.addEventListener('pointerdown', function () { control.classList.add('cw-press'); });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (eventName) {
        control.addEventListener(eventName, function () { control.classList.remove('cw-press'); });
      });
    });
  }

  function prepareGalleryFeedback(scope) {
    var selector = '.codex-pdp__gallery-arrow, .codex-pdp__thumb, .codex-pdp__zoom-arrow';
    nodesIncludingScope(scope || document, selector).forEach(function (control) {
      if (control.dataset.cwGalleryReady === 'true') return;
      control.dataset.cwGalleryReady = 'true';
      control.addEventListener('click', function () {
        var product = control.closest('.codex-pdp') || document.querySelector('.codex-pdp');
        var stage = product && product.querySelector('.codex-pdp__media-stage');
        if (!stage || reducedMotion) return;
        stage.classList.remove('cw-gallery-pulse');
        window.requestAnimationFrame(function () {
          stage.classList.add('cw-gallery-pulse');
        });
        window.setTimeout(function () {
          stage.classList.remove('cw-gallery-pulse');
        }, 520);
      });
    });
  }

  function prepareGallerySwipe(scope) {
    var galleries = nodesIncludingScope(scope || document, '[data-pdp-gallery], [data-pdp-zoom-overlay]');
    galleries.forEach(function (gallery) {
      if (gallery.dataset.cwSwipeReady === 'true') return;
      gallery.dataset.cwSwipeReady = 'true';

      var gesture = null;
      var suppressTrustedClickUntil = 0;

      gallery.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' || event.button !== 0) return;
        gesture = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          started: Date.now()
        };
      }, { passive: true });

      gallery.addEventListener('pointercancel', function () {
        gesture = null;
      }, { passive: true });

      gallery.addEventListener('pointerup', function (event) {
        if (!gesture || gesture.id !== event.pointerId) return;
        var deltaX = event.clientX - gesture.x;
        var deltaY = event.clientY - gesture.y;
        var duration = Date.now() - gesture.started;
        gesture = null;

        if (duration > 800 || Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.2) return;

        var previousSelector = gallery.matches('[data-pdp-zoom-overlay]') ? '[data-pdp-zoom-prev]' : '[data-pdp-gallery-prev]';
        var nextSelector = gallery.matches('[data-pdp-zoom-overlay]') ? '[data-pdp-zoom-next]' : '[data-pdp-gallery-next]';
        var control = gallery.querySelector(deltaX > 0 ? previousSelector : nextSelector);
        if (!control || control.disabled) return;

        event.preventDefault();
        control.click();
        suppressTrustedClickUntil = Date.now() + 450;
      }, { passive: false });

      gallery.addEventListener('click', function (event) {
        if (!event.isTrusted || Date.now() >= suppressTrustedClickUntil) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    });
  }

  function saveBodyLockStyles() {
    if (mobileFilterBodyStyles) return;
    mobileFilterBodyStyles = {
      position: document.body.style.position,
      top: document.body.style.top,
      left: document.body.style.left,
      right: document.body.style.right,
      width: document.body.style.width,
      overflow: document.body.style.overflow
    };
  }

  function mobileFilterFocusables(disclosure) {
    if (!disclosure) return [];
    return Array.prototype.slice.call(disclosure.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0;
    });
  }

  function setMobileFilterMarketSuppressed(suppressed) {
    Array.prototype.forEach.call(document.querySelectorAll('.editorial-localization'), function (root) {
      var openSelect = root.querySelector('.cw-select.is-open');
      if (suppressed) {
        if (openSelect) closeCustomSelect(openSelect, false);
        root.dataset.cwFilterSuppressed = 'true';
        root.setAttribute('aria-hidden', 'true');
        if ('inert' in root) root.inert = true;
        return;
      }

      root.removeAttribute('aria-hidden');
      if ('inert' in root) root.inert = false;
      root.hidden = false;
      root.style.removeProperty('display');
      delete root.dataset.cwFilterSuppressed;
    });
  }

  function prepareProductFilterTriggers() {
    nodesIncludingScope(document, '.codex-collection-shell').forEach(function (shell) {
      var disclosure = shell.querySelector('[data-filter-disclosure]');
      var summary = disclosure && disclosure.querySelector('.catalog-controls__summary');
      var form = disclosure && disclosure.querySelector('[data-catalog-controls-form]');
      var results = shell.querySelector('.codex-collection-results');
      var grid = results && (results.querySelector('#ResultsList') || results.querySelector('.codex-empty-collection'));
      if (!summary || !form || !grid) return;

      var trigger = results.querySelector('[data-product-filter-trigger]');
      if (!trigger) {
        trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'catalog-controls__product-trigger';
        trigger.dataset.productFilterTrigger = '';
        trigger.setAttribute('aria-haspopup', 'dialog');
        var label = document.createElement('span');
        label.textContent = summary.querySelector('span').textContent;
        var count = document.createElement('strong');
        count.dataset.productFilterCount = '';
        trigger.appendChild(label);
        trigger.appendChild(count);
        grid.parentNode.insertBefore(trigger, grid);
      }

      if (!form.id) form.id = 'AgainoraMobileFilters-' + form.dataset.sectionId;
      trigger.setAttribute('aria-controls', form.id);
      trigger.setAttribute('aria-expanded', String(Boolean(mobileFilterMedia && mobileFilterMedia.matches && disclosure.open)));
      var sourceCount = summary.querySelector('[data-active-filter-count]');
      var targetCount = trigger.querySelector('[data-product-filter-count]');
      var countText = sourceCount ? sourceCount.textContent : '';
      if (targetCount.textContent !== countText) targetCount.textContent = countText;
      shell.dataset.filterTriggerPosition = 'products';
    });
  }

  function lockMobileFilter(disclosure) {
    if (!mobileFilterMedia || !mobileFilterMedia.matches || activeMobileFilter === disclosure) return;
    if (activeMobileFilter && activeMobileFilter !== disclosure) activeMobileFilter.open = false;
    Array.prototype.forEach.call(document.querySelectorAll('.editorial-localization .cw-select.is-open'), function (wrapper) {
      closeCustomSelect(wrapper, false);
    });

    activeMobileFilter = disclosure;
    var shell = disclosure.closest('.codex-collection-shell');
    mobileFilterTrigger = (shell && shell.querySelector('[data-product-filter-trigger]')) || disclosure.querySelector('summary');
    if (mobileFilterTrigger) mobileFilterTrigger.setAttribute('aria-expanded', 'true');
    mobileFilterScrollY = window.scrollY || document.documentElement.scrollTop || 0;
    saveBodyLockStyles();
    document.body.classList.add('cw-filter-overlay-open');
    setMobileFilterMarketSuppressed(true);
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + mobileFilterScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
    var dialog = disclosure.querySelector('.catalog-controls__form--facets');
    if (dialog) {
      dialog.setAttribute('role', 'dialog');
      dialog.setAttribute('aria-modal', 'true');
      dialog.setAttribute('aria-label', dialog.getAttribute('data-dialog-label') || 'Filters and sorting');
    }

    window.requestAnimationFrame(function () {
      if (activeMobileFilter !== disclosure) return;
      var initialFocus = disclosure.querySelector('[data-filter-close]') || mobileFilterFocusables(disclosure)[0];
      if (initialFocus) initialFocus.focus();
    });
  }

  function unlockMobileFilter(disclosure, restoreFocus) {
    if (!activeMobileFilter) {
      document.body.classList.remove('cw-filter-overlay-open');
      setMobileFilterMarketSuppressed(false);
      return;
    }
    if (disclosure && activeMobileFilter !== disclosure) return;
    var shell = activeMobileFilter.closest('.codex-collection-shell');
    var trigger = (shell && shell.querySelector('[data-product-filter-trigger]')) || mobileFilterTrigger;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    var scrollY = mobileFilterScrollY;
    var styles = mobileFilterBodyStyles || {};

    var dialog = activeMobileFilter.querySelector('.catalog-controls__form--facets');
    if (dialog) {
      dialog.removeAttribute('role');
      dialog.removeAttribute('aria-modal');
    }
    activeMobileFilter = null;
    mobileFilterTrigger = null;
    mobileFilterBodyStyles = null;
    document.body.classList.remove('cw-filter-overlay-open');
    setMobileFilterMarketSuppressed(false);
    document.body.style.position = styles.position || '';
    document.body.style.top = styles.top || '';
    document.body.style.left = styles.left || '';
    document.body.style.right = styles.right || '';
    document.body.style.width = styles.width || '';
    document.body.style.overflow = styles.overflow || '';

    window.requestAnimationFrame(function () {
      window.scrollTo(0, scrollY);
      if (restoreFocus && trigger && document.documentElement.contains(trigger)) trigger.focus();
    });
  }

  function closeMobileFilter(restoreFocus) {
    if (!activeMobileFilter) return;
    var disclosure = activeMobileFilter;
    var form = disclosure.querySelector('[data-catalog-controls-form]');
    if (form) form.dispatchEvent(new CustomEvent('againora:filters-cancel'));
    disclosure.open = false;
    unlockMobileFilter(disclosure, restoreFocus);
  }

  function bindMobileFilterEvents() {
    if (mobileFilterEventsBound) return;
    mobileFilterEventsBound = true;

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-product-filter-trigger]');
      if (!trigger || !mobileFilterMedia || !mobileFilterMedia.matches) return;
      var form = document.getElementById(trigger.getAttribute('aria-controls'));
      var disclosure = form && form.closest('[data-filter-disclosure]');
      if (!disclosure) return;
      event.preventDefault();
      disclosure.open = true;
      lockMobileFilter(disclosure);
    });

    document.addEventListener('againora:collection-updated', prepareProductFilterTriggers);

    document.addEventListener('keydown', function (event) {
      if (!activeMobileFilter) return;

      if (event.key === 'Escape' && !document.querySelector('.cw-select.is-open')) {
        event.preventDefault();
        closeMobileFilter(true);
        return;
      }

      if (event.key !== 'Tab') return;
      var focusable = mobileFilterFocusables(activeMobileFilter);
      if (!focusable.length) {
        event.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;
      if (event.shiftKey && (active === first || !activeMobileFilter.contains(active))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (active === last || !activeMobileFilter.contains(active))) {
        event.preventDefault();
        first.focus();
      }
    });

    if (mobileFilterMedia) {
      var handleViewportChange = function (event) {
        if (event.matches) {
          nodesIncludingScope(document, '[data-filter-disclosure]').forEach(function (disclosure) {
            if (disclosure.open) disclosure.open = false;
          });
          unlockMobileFilter(null, false);
          return;
        }

        closeMobileFilter(false);
        nodesIncludingScope(document, '[data-filter-disclosure]').forEach(function (disclosure) {
          disclosure.open = true;
        });
      };
      if (mobileFilterMedia.addEventListener) mobileFilterMedia.addEventListener('change', handleViewportChange);
      else if (mobileFilterMedia.addListener) mobileFilterMedia.addListener(handleViewportChange);
    }

    window.addEventListener('pageshow', function () {
      if (activeMobileFilter) return;
      document.body.classList.remove('cw-filter-overlay-open');
      setMobileFilterMarketSuppressed(false);
    });
  }

  function prepareMobileFilters(scope) {
    nodesIncludingScope(scope || document, '[data-filter-disclosure]').forEach(function (disclosure) {
      if (disclosure.dataset.cwMobileFilterReady === 'true') return;
      disclosure.dataset.cwMobileFilterReady = 'true';

      var summary = disclosure.querySelector('.catalog-controls__summary');
      if (summary && window.MutationObserver) {
        new MutationObserver(prepareProductFilterTriggers).observe(summary, { childList: true, subtree: true, characterData: true });
      }

      disclosure.addEventListener('toggle', function () {
        if (!mobileFilterMedia || !mobileFilterMedia.matches) {
          unlockMobileFilter(disclosure, false);
          return;
        }
        if (disclosure.open) lockMobileFilter(disclosure);
        else unlockMobileFilter(disclosure, false);
      });

      var form = disclosure.querySelector('[data-catalog-controls-form]');
      var closeButton = disclosure.querySelector('[data-filter-close]');
      var applyCloseButton = form && form.querySelector('[data-filter-apply-close], .catalog-controls__actions button[type="submit"]');
      if (applyCloseButton && closeButton) {
        applyCloseButton.dataset.filterApplyClose = '';
      }
      if (closeButton) {
        closeButton.addEventListener('click', function (event) {
          event.preventDefault();
          if (form) form.dispatchEvent(new CustomEvent('againora:filters-cancel'));
          if (activeMobileFilter !== disclosure) mobileFilterTrigger = disclosure.querySelector('summary');
          disclosure.open = false;
          unlockMobileFilter(disclosure, true);
        });
      }

      if (mobileFilterMedia && mobileFilterMedia.matches) disclosure.open = false;
      else disclosure.open = true;
    });
    prepareProductFilterTriggers();
    bindMobileFilterEvents();
  }
  function customSelectMenu(wrapper) {
    return wrapper && (wrapper._cwMenu || wrapper.querySelector('.cw-select__menu'));
  }

  function positionFloatingSelect(wrapper) {
    var trigger = wrapper && wrapper.querySelector('.cw-select__button');
    var menu = customSelectMenu(wrapper);
    if (!trigger || !menu || !menu.classList.contains('cw-select__menu--floating')) return;
    var rect = trigger.getBoundingClientRect();
    var viewportWidth = document.documentElement.clientWidth;
    var viewportHeight = document.documentElement.clientHeight;
    var minimumWidth = wrapper.dataset.cwSelectAlign === 'right' ? 172 : 152;
    var menuWidth = Math.min(Math.max(rect.width, minimumWidth), Math.max(120, viewportWidth - 20));
    var preferredLeft = wrapper.dataset.cwSelectAlign === 'right' ? rect.right - menuWidth : rect.left;
    var left = Math.max(10, Math.min(preferredLeft, viewportWidth - menuWidth - 10));
    menu.style.width = menuWidth + 'px';
    menu.style.left = left + 'px';
    menu.style.right = 'auto';
    menu.style.top = rect.bottom + 7 + 'px';
    menu.style.bottom = 'auto';
    var menuHeight = menu.offsetHeight;
    if (rect.bottom + 7 + menuHeight > viewportHeight - 10 && rect.top > viewportHeight - rect.bottom) {
      menu.style.top = 'auto';
      menu.style.bottom = viewportHeight - rect.top + 7 + 'px';
    }
  }

  function scheduleFloatingSelectPosition() {
    if (customSelectPositionFrame) return;
    customSelectPositionFrame = window.requestAnimationFrame(function () {
      customSelectPositionFrame = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.cw-select.is-open[data-cw-select-floating="true"]'), positionFloatingSelect);
    });
  }

  function closeCustomSelect(wrapper, restoreFocus) {
    if (!wrapper || !wrapper.classList.contains('is-open')) return;
    var trigger = wrapper.querySelector('.cw-select__button');
    var menu = customSelectMenu(wrapper);
    wrapper.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (menu) {
      menu.hidden = true;
      if (menu.classList.contains('cw-select__menu--floating')) {
        menu.classList.remove('cw-select__menu--floating');
        menu.removeAttribute('style');
        wrapper.appendChild(menu);
      }
    }
    if (restoreFocus && trigger) trigger.focus();
  }

  function closeOtherCustomSelects(current) {
    Array.prototype.forEach.call(document.querySelectorAll('.cw-select.is-open'), function (wrapper) {
      if (wrapper !== current) closeCustomSelect(wrapper, false);
    });
  }

  function bindCustomSelectDismissal() {
    if (customSelectEventsBound) return;
    customSelectEventsBound = true;
    document.addEventListener('click', function (event) {
      Array.prototype.forEach.call(document.querySelectorAll('.cw-select.is-open'), function (wrapper) {
        var menu = customSelectMenu(wrapper);
        if (!wrapper.contains(event.target) && !(menu && menu.contains(event.target))) closeCustomSelect(wrapper, false);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var openSelect = document.querySelector('.cw-select.is-open');
      if (openSelect) {
        event.preventDefault();
        closeCustomSelect(openSelect, true);
      }
    });
    window.addEventListener('resize', scheduleFloatingSelectPosition, { passive: true });
    window.addEventListener('scroll', scheduleFloatingSelectPosition, { passive: true, capture: true });
  }

  function prepareCustomSelects(scope) {
    nodesIncludingScope(scope || document, '.editorial-localization select').forEach(function (select) {
      if (select.dataset.cwSelectReady === 'true') return;
      var label = select.closest('label');
      if (!label) return;

      select.dataset.cwSelectReady = 'true';
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;
      label.classList.add('cw-select-enhanced');

      customSelectId += 1;
      var id = 'cw-filter-options-' + customSelectId;
      var wrapper = document.createElement('div');
      var trigger = document.createElement('button');
      var value = document.createElement('span');
      var arrow = document.createElement('span');
      var menu = document.createElement('div');
      var typeBuffer = '';
      var typeTimer = 0;

      wrapper.className = 'cw-select';
      wrapper._cwMenu = menu;
      if (select.closest('.editorial-localization')) {
        wrapper.dataset.cwSelectFloating = 'true';
        wrapper.dataset.cwSelectAlign = select.closest('#EditorialLanguageSelector') ? 'right' : 'left';
      }
      trigger.type = 'button';
      trigger.className = 'cw-select__button';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', id);
      value.className = 'cw-select__value';
      arrow.className = 'cw-select__arrow';
      arrow.setAttribute('aria-hidden', 'true');
      /* Keep the arrow empty: the single chevron is drawn in CSS. A text glyph
         here can stack with Horizon's button decoration and look doubled. */
      arrow.textContent = '';
      trigger.appendChild(value);
      trigger.appendChild(arrow);

      menu.id = id;
      menu.className = 'cw-select__menu';
      menu.setAttribute('role', 'listbox');
      menu.setAttribute('aria-label', select.getAttribute('aria-label') || 'Options');
      menu.hidden = true;
      wrapper.appendChild(trigger);
      wrapper.appendChild(menu);
      select.insertAdjacentElement('afterend', wrapper);

      function optionNodes() {
        return Array.prototype.slice.call(menu.querySelectorAll('.cw-select__option:not([aria-disabled="true"])'));
      }

      function updateTrigger() {
        var selected = select.options[select.selectedIndex] || select.options[0];
        var text = selected ? selected.textContent.trim() : '';
        value.textContent = text;
        trigger.disabled = select.disabled;
        trigger.setAttribute('aria-label', (select.getAttribute('aria-label') || 'Filter') + ': ' + text);
      }

      function chooseOption(nativeOption) {
        if (!nativeOption || nativeOption.disabled) return;
        var changed = select.value !== nativeOption.value;
        select.value = nativeOption.value;
        updateTrigger();
        closeCustomSelect(wrapper, true);
        if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
      }

      function rebuildMenu() {
        menu.textContent = '';
        Array.prototype.forEach.call(select.options, function (nativeOption, nativeIndex) {
          if (nativeOption.hidden) return;
          var option = document.createElement('div');
          var selected = nativeOption.selected;
          option.className = 'cw-select__option' + (selected ? ' is-selected' : '');
          option.setAttribute('role', 'option');
          option.setAttribute('tabindex', '-1');
          option.setAttribute('aria-selected', selected ? 'true' : 'false');
          option.setAttribute('aria-disabled', nativeOption.disabled ? 'true' : 'false');
          option.dataset.nativeIndex=nativeIndex;
          option.textContent = nativeOption.textContent.trim();
          option.addEventListener('click', function (event) {
            event.preventDefault();
            chooseOption(nativeOption);
          });
          menu.appendChild(option);
        });
        updateTrigger();
      }

      function focusMenuOption(direction) {
        var options = optionNodes();
        if (!options.length) return;
        var selected = menu.querySelector('.cw-select__option[aria-selected="true"]');
        var target = selected || (direction < 0 ? options[options.length - 1] : options[0]);
        target.focus();
        target.scrollIntoView({ block: 'nearest' });
      }

      function openMenu(direction) {
        rebuildMenu();
        closeOtherCustomSelects(wrapper);
        wrapper.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
        if (wrapper.dataset.cwSelectFloating === 'true') {
          menu.classList.add('cw-select__menu--floating');
          document.body.appendChild(menu);
          positionFloatingSelect(wrapper);
        }
        window.requestAnimationFrame(function () { focusMenuOption(direction || 1); });
      }

      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        if (wrapper.classList.contains('is-open')) closeCustomSelect(wrapper, false);
        else openMenu(1);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openMenu(event.key === 'ArrowUp' ? -1 : 1);
      });

      menu.addEventListener('keydown', function (event) {
        var options = optionNodes();
        if (!options.length) return;
        var currentIndex = options.indexOf(document.activeElement);
        var nextIndex = currentIndex;

        if (event.key === 'ArrowDown') nextIndex = Math.min(options.length - 1, currentIndex + 1);
        else if (event.key === 'ArrowUp') nextIndex = Math.max(0, currentIndex - 1);
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = options.length - 1;
        else if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          var nativeOption=select.options[document.activeElement.dataset.nativeIndex];
          chooseOption(nativeOption);
          return;
        } else if (event.key.length === 1 && !event.altKey && !event.ctrlKey && !event.metaKey) {
          typeBuffer += event.key.toLowerCase();
          window.clearTimeout(typeTimer);
          typeTimer = window.setTimeout(function () { typeBuffer = ''; }, 650);
          var start = Math.max(currentIndex, 0);
          for (var offset = 1; offset <= options.length; offset += 1) {
            var candidate = options[(start + offset) % options.length];
            if (candidate.textContent.trim().toLowerCase().indexOf(typeBuffer) === 0) {
              nextIndex = options.indexOf(candidate);
              break;
            }
          }
        } else {
          return;
        }

        event.preventDefault();
        options[nextIndex].focus();
        options[nextIndex].scrollIntoView({ block: 'nearest' });
      });

      select.addEventListener('change', function () {
        rebuildMenu();
      });

      rebuildMenu();
      bindCustomSelectDismissal();
    });
  }

  function syncLocalizationSelectMode(scope) {
    var useNativeMobileControls = Boolean(mobileFilterMedia && mobileFilterMedia.matches);
    nodesIncludingScope(scope || document, '.editorial-localization select').forEach(function (select) {
      var label = select.closest('label');
      var wrapper = select.nextElementSibling;
      if (!label || !wrapper || !wrapper.classList.contains('cw-select')) return;

      var nativeMode = useNativeMobileControls && Boolean(select.closest('[data-editorial-localization-mobile-slot]'));
      var trigger = wrapper.querySelector('.cw-select__button');
      if (nativeMode && wrapper.classList.contains('is-open')) closeCustomSelect(wrapper, false);

      label.classList.toggle('cw-select-native', nativeMode);
      wrapper.hidden = nativeMode;
      wrapper.setAttribute('aria-hidden', nativeMode ? 'true' : 'false');
      if ('inert' in wrapper) wrapper.inert = nativeMode;
      if (trigger) trigger.tabIndex = nativeMode ? -1 : 0;

      if (nativeMode) {
        select.removeAttribute('aria-hidden');
        select.tabIndex = 0;
      } else {
        select.setAttribute('aria-hidden', 'true');
        select.tabIndex = -1;
      }
    });
  }

  function bindLocalizationSelectMode() {
    if (localizationSelectEventsBound) return;
    localizationSelectEventsBound = true;

    var sync = function () {
      window.requestAnimationFrame(function () {
        prepareCustomSelects(document);
        syncLocalizationSelectMode(document);
      });
    };
    document.addEventListener('editorial:market-mounted', sync);
    window.addEventListener('pageshow', sync);
    if (mobileFilterMedia) {
      if (mobileFilterMedia.addEventListener) mobileFilterMedia.addEventListener('change', sync);
      else if (mobileFilterMedia.addListener) mobileFilterMedia.addListener(sync);
    }
  }

  function prepareFilterFeedback(scope) {
    nodesIncludingScope(scope || document, '.catalog-controls__form').forEach(function (form) {
      if (form.dataset.cwFilterMotionReady === 'true') return;
      form.dataset.cwFilterMotionReady = 'true';
      form.addEventListener('submit', function () {
        document.body.classList.add('cw-filter-loading');
        window.setTimeout(function () {
          document.body.classList.remove('cw-filter-loading');
        }, 3000);
      });
    });
  }

  function prepareCampaignTimers(scope) {
    nodesIncludingScope(scope || document, '[data-cw-campaign-end]').forEach(function (bar) {
      if (bar.dataset.cwCampaignTimerReady === 'true') return;
      var end = new Date(bar.getAttribute('data-cw-campaign-end') || '');
      var output = bar.querySelector('[data-cw-campaign-countdown]');
      if (!output || !Number.isFinite(end.getTime())) return;
      bar.dataset.cwCampaignTimerReady = 'true';

      function update() {
        if (!document.documentElement.contains(bar)) {
          window.clearInterval(timer);
          return;
        }
        var remaining = end.getTime() - Date.now();
        if (remaining <= 0) {
          bar.dataset.cwCampaignExpired = 'true';
          bar.hidden = true;
          bar.setAttribute('aria-hidden', 'true');
          window.clearInterval(timer);
          bar.remove();
          return;
        }
        var totalSeconds = Math.ceil(remaining / 1000);
        var days = Math.floor(totalSeconds / 86400);
        var hours = Math.floor((totalSeconds % 86400) / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;
        var clock = [hours, minutes, seconds].map(function (part) {
          return String(part).padStart(2, '0');
        }).join(':');
        output.textContent = days > 0 ? days + 'd ' + clock : clock;
      }

      var timer = window.setInterval(update, 1000);
      update();
    });
  }

  function enhance(scope) {
    fixCustomerPrivacyPolicyLinks(scope || document);
    normalizeVisibleProductSizes(scope || document);
    prepareReveals(scope || document);
    prepareCustomSelects(scope || document);
    syncLocalizationSelectMode(scope || document);
    preparePressFeedback(scope || document);
    prepareGalleryFeedback(scope || document);
    prepareGallerySwipe(scope || document);
    prepareMobileFilters(scope || document);
    prepareFilterFeedback(scope || document);
    prepareCampaignTimers(scope || document);
  }

  var dynamicEnhancementSelector = [
    revealSelector,
    '#shopify-pc__banner__body-policy-link',
    '.codex-pdp__title',
    '.codex-pdp__crumbs',
    'a[href*="/products/"]',
    '.editorial-localization select',
    '.editorial-button',
    '.codex-pdp__add',
    '.catalog-controls__form',
    '.product-card-wrapper button',
    '[data-pdp-gallery]',
    '[data-pdp-zoom-overlay]',
    '[data-filter-disclosure]',
    '[data-cw-campaign-end]'
  ].join(',');

  function queueEnhancement(node) {
    if (!node || node.nodeType !== 1) return;
    var isRelevant = node.matches(dynamicEnhancementSelector) || node.querySelector(dynamicEnhancementSelector);
    if (!isRelevant) return;

    pendingEnhancementRoots = pendingEnhancementRoots.filter(function (rootNode) {
      return !node.contains(rootNode);
    });
    if (!pendingEnhancementRoots.some(function (rootNode) { return rootNode.contains(node); })) {
      pendingEnhancementRoots.push(node);
    }
    if (mutationFrame) return;

    mutationFrame = window.requestAnimationFrame(function () {
      var roots = pendingEnhancementRoots.slice();
      pendingEnhancementRoots = [];
      mutationFrame = 0;
      roots.forEach(function (rootNode) {
        if (rootNode.isConnected) enhance(rootNode);
      });
    });
  }

  function observeDynamicContent() {
    if (!('MutationObserver' in window) || mutationObserver) return;
    mutationObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, queueEnhancement);
      });
    });
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function initialize() {
    enhance(document);
    bindLocalizationSelectMode();
    bindScrollState();
    observeDynamicContent();
  }

  if (!reducedMotion) root.classList.add('cw-motion-ready');
  root.classList.add('cw-experience');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', function (event) {
    enhance(event.target);
  });
})();
